module.exports = __webpack_public_path__ + "static/media/slide-adapt-3bis.8cf0bea0.svg";